class MiniCart extends HTMLElement {
  constructor() {
    super();
    this.isLoading = false;
  }

  connectedCallback() {
    this.header = document.querySelector('sticky-header');
    this.drawer = document.querySelector('cart-drawer');
    new IntersectionObserver(this.handleIntersection.bind(this)).observe(this);
  }

  handleIntersection(entries, observer) {
    if (!entries[0].isIntersecting) return;
    if (this.isLoading) return; // Запобігаємо повторним викликам

    observer.unobserve(this);
    this.isLoading = true;

    fetch(this.dataset.url)
      .then(response => {
        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }
        return response.text();
      })
      .then(html => {
        document.getElementById('mini-cart').innerHTML =
          this.getSectionInnerHTML(html, '.shopify-section');

        // Додаємо клас що контент завантажено
        document.getElementById('mini-cart').classList.add('content-loaded');

        document.dispatchEvent(new CustomEvent('cartdrawer:opened'));
      })
      .catch(e => {
        console.error('Error loading cart:', e);
        // На випадок помилки показуємо базовий контент
        this.showFallbackContent();
      })
      .finally(() => {
        this.isLoading = false;
      });
  }

  showFallbackContent() {
    // Простий fallback якщо fetch не працює
    const miniCart = document.getElementById('mini-cart');
    if (miniCart) {
      miniCart.innerHTML = `
        <div class="mini-cart is-empty">
          <div class="mini-cart__inner">
            <div class="mini-cart__header">
              <div class="mini-cart__logo">
                <svg viewBox="0 0 1117 117" fill="none" xmlns="http://www.w3.org/2000/svg" style="width:130px;height:auto;color:#e8c8d8;"><path d="M213.315 54.4062C213.319 55.7314 213.321 57.0567 213.321 58.3818C213.467 67.9689 214.904 83.7759 226.978 95.0947C231.999 99.7873 238.209 103.052 245.559 104.84C249.792 105.867 253.873 106.373 257.843 106.352C261.812 106.373 265.894 105.87 270.127 104.84C277.476 103.055 283.686 99.7904 288.708 95.0947C300.781 83.7759 302.221 67.9689 302.364 58.3818C302.367 57.0567 302.37 55.7314 302.37 54.4062L301.079 3.41406H317.507V60.6572C317.507 66.4268 316.705 75.7623 313.512 83.8037C308.189 96.8171 298.553 106.305 284.748 112.081C277.793 114.992 269.972 116.584 260.841 116.941C259.832 116.982 258.836 117 257.843 117C256.85 117 255.853 116.982 254.845 116.941C245.717 116.581 237.896 114.992 230.938 112.081C217.133 106.305 207.496 96.8171 202.173 83.8037C198.976 75.7624 198.179 66.4299 198.179 60.6572V3.41406H214.606L213.315 54.4062ZM717.075 0C718.068 3.55532e-06 719.065 0.0182592 720.073 0.0585938C729.201 0.418625 737.022 2.00785 743.98 4.91895C757.785 10.6948 767.421 20.183 772.744 33.1963C775.941 41.2377 776.738 50.57 776.738 56.3428V59.4346H761.596V59.4316H672.586C672.864 69.1036 674.72 83.9405 686.21 94.7129C691.232 99.4055 697.442 102.671 704.791 104.459C709.024 105.486 713.106 105.991 717.075 105.97C721.045 105.991 725.126 105.489 729.359 104.459C736.709 102.674 742.919 99.4085 747.94 94.7129C754.535 88.5306 757.956 81.0109 759.725 73.8945V73.8916H776.568C773.806 88.0905 764.923 100.945 749.827 108.962C747.947 109.943 745.998 110.855 743.98 111.699C737.025 114.61 729.204 116.203 720.073 116.56C719.065 116.6 718.068 116.618 717.075 116.618C716.082 116.618 715.086 116.6 714.077 116.56C704.95 116.2 697.128 114.61 690.17 111.699C676.365 105.923 666.728 96.436 661.405 83.4229C658.209 75.3814 657.411 66.0481 657.411 60.2754V56.3428C657.411 50.5732 658.212 41.2376 661.405 33.1963C666.728 20.1829 676.365 10.6948 690.17 4.91895C697.125 2.00787 704.947 0.415528 714.077 0.0585938C715.086 0.0182606 716.082 3.73997e-06 717.075 0ZM921.433 2.18359C931.398 -0.268227 941.411 -0.655607 951.19 1.02344C958.201 2.22767 964.455 4.72613 969.777 8.44727C970.575 9.00591 971.345 9.58559 972.087 10.1846C972.093 10.1876 972.096 10.1939 972.099 10.1943C973.501 11.3272 974.806 12.5312 976.007 13.8037C984.632 22.8383 987.301 33.8815 987.63 43.2822H972.151L971.922 41.4385C971.897 41.2275 971.872 41.038 971.848 40.8643C971.798 40.4826 971.748 40.1195 971.717 39.7285C971.18 32.9564 968.747 26.8235 964.672 21.9912C960.584 17.1465 954.945 13.7293 948.362 12.1123C938.685 9.73502 928.999 10.492 919.57 14.3652C916.063 15.8053 913.068 17.9933 910.669 20.8672C907.854 24.2377 906.585 29.1387 907.357 33.6514C907.885 36.7364 909.62 41.0691 914.899 44.21C918.742 46.4973 923.155 47.9277 928.788 48.7129C931.923 49.1474 935.113 49.5792 938.201 49.9951C943.986 50.7741 949.97 51.581 955.854 52.4717C963.359 53.6076 969.8 55.6742 975.538 58.7871C980.935 61.7169 984.885 65.2651 987.61 69.6318L987.623 69.6406C991.189 75.3605 992.375 81.9154 991.14 89.125C989.842 96.7101 985.721 102.939 978.884 107.645C974.194 110.872 968.784 113.098 962.348 114.454C960.209 114.904 958.083 115.271 955.967 115.565C955.97 115.568 955.973 115.568 955.973 115.568C955.839 115.587 955.703 115.605 955.566 115.624C955.473 115.636 955.383 115.649 955.29 115.661C954.657 115.742 954.018 115.819 953.369 115.891C953.205 115.909 953.042 115.928 952.878 115.943C952.276 116.005 951.668 116.062 951.051 116.114C950.899 116.127 950.746 116.139 950.594 116.151C938.878 117.07 925.026 115.891 913.111 110.171C913.108 110.174 913.105 110.174 913.105 110.174C913.05 110.146 913 110.118 912.944 110.09C909.583 108.46 906.377 106.474 903.419 104.062C886.173 90.557 887.034 73.662 887.038 73.5889H901.933C901.951 73.6724 901.97 73.7498 901.988 73.8271C902.069 74.1654 902.181 74.6313 902.209 75.1992C902.463 80.3605 904.341 85.0628 907.95 89.5723C912.072 94.7242 917.544 98.6592 924.679 101.604C931.73 104.516 939.235 105.801 947.618 105.528C953.648 105.333 958.468 104.575 962.782 103.142C966.904 101.773 969.952 100.047 972.382 97.71C977.822 92.4742 978.892 83.834 974.87 77.6113C973.225 75.0665 970.833 72.9496 967.556 71.1465C963.316 68.8157 958.422 67.2575 952.587 66.3916C946.417 65.4729 940.12 64.625 934.03 63.8057C931.833 63.5108 929.636 63.213 927.441 62.915C921.79 62.1453 916.951 60.9414 912.649 59.2344C910.75 58.4833 908.975 57.6452 907.367 56.7451L907.28 56.6953C904.636 55.1187 901.445 52.9559 898.761 49.6475L898.531 49.7812L896.514 46.3604C894.096 42.1054 892.92 37.0712 892.92 30.9883L892.932 30.6934C893.664 21.8421 898.053 14.5398 905.977 8.98438C910.412 5.87456 915.467 3.6485 921.433 2.18359ZM487.462 1.70703C488.455 1.70703 489.451 1.72528 490.46 1.76562C499.588 2.12565 507.409 3.71481 514.367 6.62598C528.172 12.4018 537.808 21.89 543.131 34.9033C546.328 42.9447 547.126 52.2771 547.126 58.0498V115.293H530.698L531.989 64.3008C531.986 62.9756 531.983 61.6503 531.983 60.3252C531.838 50.7382 530.4 34.9312 518.327 23.6123C513.306 18.9197 507.095 15.6549 499.746 13.8672C495.513 12.8399 491.431 12.3338 487.462 12.3555C483.492 12.3337 479.411 12.8368 475.178 13.8672C467.828 15.6517 461.618 18.9166 456.597 23.6123C444.524 34.9312 443.083 50.7381 442.94 60.3252C442.937 61.6503 442.935 62.9756 442.935 64.3008L444.226 115.293H427.798V58.0498C427.798 52.2802 428.598 42.9447 431.792 34.9033C437.115 21.8899 446.752 12.4018 460.557 6.62598C467.512 3.71484 475.333 2.12254 484.464 1.76562C485.472 1.72529 486.469 1.70703 487.462 1.70703ZM14.1123 102.258H14.1152L87.8848 99.3311V113.729H0V3.41406H16.4863L14.1123 102.258ZM1116.42 113.72H1101.9V3.41406H1116.42V113.72ZM717.075 10.6484C713.106 10.6267 709.024 11.1298 704.791 12.1602C697.442 13.9447 691.231 17.2097 686.21 21.9053C678.225 29.3917 674.891 38.8415 673.508 47.1562L760.537 46.5684C759.095 38.3987 755.738 29.2156 747.94 21.9053C742.919 17.2128 736.708 13.9478 729.359 12.1602C725.126 11.1329 721.045 10.6267 717.075 10.6484Z" fill="currentColor"/></svg>
              </div>
              <drawer-close-button class="header__icon header__icon--summary header__icon--cart">
                <svg class="icon icon-close" aria-hidden="true" focusable="false">
                  <use href="#icon-close"></use>
                </svg>
              </drawer-close-button>
              <div class="title h4">Cart</div>
            </div>
            <div class="mini-cart__empty center">
              <p class="mini-cart__empty-text h3">Your cart is empty</p>
              <a href="${theme.shopSettings.emptyCartRedirectUrl}" class="button">Continue shopping</a>
            </div>
          </div>
        </div>
      `;
      miniCart.classList.add('content-loaded');
    }
  }

  open() {
    const detailsElement = this.drawer.querySelector('details');
    if (detailsElement.hasAttribute('open')) {
      return;
    }

    // Чекаємо трохи якщо контент ще завантажується
    if (this.isLoading) {
      setTimeout(() => this.open(), 100);
      return;
    }

    this.drawer.openMenuDrawer();
  }

  renderContents(parsedState) {
    this.productId = parsedState.id;
    this.getSectionsToRender().forEach((section => {
      if (document.getElementById(section.id)) {
        document.getElementById(section.id).innerHTML =
          this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
      }
    }));

    // Додаємо клас що контент завантажено
    document.getElementById('mini-cart').classList.add('content-loaded');
    this.open();
    document.dispatchEvent(new CustomEvent('cartdrawer:opened'));
  }

  getSectionsToRender() {
    return [
      {
        id: 'mini-cart',
        section: 'mini-cart',
        selector: '.shopify-section'
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section'
      },
      {
        id: 'mobile-cart-icon-bubble',
        section: 'mobile-cart-icon-bubble',
        selector: '.shopify-section'
      }
    ];
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector).innerHTML;
  }
}

customElements.define('mini-cart', MiniCart);